import AppProvider from './context/AppProvider'
import ThemeSwitcher from './components/ThemeSwitcher'
import Ads from './components/Ads'
import Logo from './logo-name.svg?url'
import { FaPhone } from 'react-icons/fa'
import nanowebConfig from '../nanoweb.config'
import { LiaFacebookMessenger, LiaWhatsapp } from "react-icons/lia"

function WebApp() {
	const onCall = (event) => {
		event.preventDefault()
		window.fbq?.("track", "Lead")

		// Google Analytics
		window.gtag?.("event", "phone_call", {
			event_category: "Contact",
			event_label: nanowebConfig.TELEPHONE_URL,
			value: 1,
			debug_mode: true,
		})

		setTimeout(() => {
			window.open(nanowebConfig.TELEPHONE_URL, "_blank")
		}, 333)
	}

	const onChat = (event, uri) => {
		event.preventDefault()
		window.fbq?.("track", "Contact")

		// Google Analytics
		window.gtag?.("event", "chat_start", {
			event_category: "Contact",
			event_label: uri ?? nanowebConfig.WHATSAPP_URL,
			value: 1,
			debug_mode: true,
		})

		setTimeout(() => {
			window.open(uri ?? nanowebConfig.WHATSAPP_URL, "_blank")
		}, 333)
	}
	return (
		<AppProvider>
			<header
				className='sticky-md-top fixed-bottom bg-body'
			>
				<div
					className='container d-flex p-2 align-items-center justify-content-between'
					style={{ maxWidth: '45rem' }}
				>
					<a href={nanowebConfig.TELEPHONE_URL} className='btn btn-outline-primary' onClick={onCall}>
						<FaPhone />
						<span className='ms-2'>{nanowebConfig.TELEPHONE}</span>
					</a>
					<a href={nanowebConfig.FACEBOOK_MESSENGER_URL} className='btn btn-link text-primary' title='We are on Facebook' onClick={e => onChat(e, nanowebConfig.FACEBOOK_MESSENGER_URL)}>
						<LiaFacebookMessenger size={33} />
						<span className='d-none d-sm-inline'>Messenger</span>
					</a>
					<a href={nanowebConfig.WHATSAPP_URL} className='btn btn-link text-success' title='Chat us in WhatsApp' onClick={onChat}>
						<LiaWhatsapp size={33} />
						<span className='d-none d-sm-inline'>WhatsApp</span>
					</a>
					<ThemeSwitcher className='p-0' />
				</div>
			</header>
			<div className='pb-5'>
				<figure className='bg-white circle d-flex align-items-center justify-content-center m-0 p-5'>
					<img src={Logo} alt="Logo" style={{ height: '135px' }} />
				</figure>
				{/* Main Content */}
				<main className="container py-5">
					<Ads hideHeader onCall={onCall} onChat={onChat} />
				</main>
			</div>
		</AppProvider>
	)
}

export default WebApp
